export const errorCodeMap = new Map<string, string>([
  ['RE-002', 'timeline.refreshError.requestedTooSoon'],
  ['RE-004', 'timeline.refreshError.notRefreshable'],
  ['AJG-003', 'strava.connection.alreadyConnected'],
  ['AST-001', 'strava.connection.warningScope'],
]);
